import { render, staticRenderFns } from "./aicaigouSearch.vue?vue&type=template&id=1928e0b4&scoped=true&"
import script from "./aicaigouSearch.vue?vue&type=script&lang=js&"
export * from "./aicaigouSearch.vue?vue&type=script&lang=js&"
import style0 from "./aicaigouSearch.vue?vue&type=style&index=0&id=1928e0b4&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1928e0b4",
  null
  
)

export default component.exports